<template>
  <section class="selftests__modal">
    <div class="loading" v-if="load">
      <div class="spinner" style="top: 5px">
        <scale-loader />
      </div>
    </div>

    <div class="setting-card">
      <h4 class="title">
        <span>{{ 'Test #' + data.id }}</span>
        <span>{{ get_date(data.ts) }}</span>
      </h4>

      <div v-if="result_test">
        <p class="duration" v-if="duration">{{ translate('speed.duration') }}: {{ duration }}</p>
        <p class="duration" v-if="server">{{ translate('speed.server') }}: {{ server }}</p>
        <p class="duration" v-if="data.descr">{{ translate('speed.description') }}: {{ data.descr }}</p>

        <div class="response_table" v-if="Object.keys(result_data).length > 0">
          <table>
            <thead>
            <tr>
              <th rowspan="1" class="traffic_block">
                {{ translate('parameters') }} / {{ translate('self_tests.ifaces') }}
              </th>
              <th v-for="(item,key) in th" :key="key" class="traffic_block">
                {{ item.name }}
              </th>
            </tr>
            </thead>


            <tbody>
            <tr v-for="(item2,key2) in tr" :key="key2">
              <td class="tdFont traffic_block">
                {{ translate("self_tests." + item2.name2) }}
              </td>
              <td v-for="(val,dkey) in ifaces" :key="dkey">
                {{ result_data[val][item2.name2][0] }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="result_speed_test response_table" v-if="Object.keys(speed_test_result).length">
          <table>
            <thead>
            <tr>
              <th>Симкарта</th>
              <th>Скорость rx</th>
              <th>Скорость tx</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, sim) in speed_test_result" :key="sim">
              <td>{{ sim }}</td>
              <td>{{ item.rx }}</td>
              <td>{{ item.tx }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else>
        <p class="duration">{{ translate('no_data') }}</p>
      </div>
    </div>

    <div class="text-center">
      <button
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </section>
</template>

<script>


export default {
  name: "SelfTestItem",
  props: ['type', 'data'],
  data () {
    return {
      load: false,
      th: [],
      tr: [],
      ifaces: [],
      result_data: {},
      speed_test_result: {},
      duration: 0,
      server: null,

      old_url: null
    }
  },

  computed:{
    result_test(){
      return Object.keys(this.result_data).length > 0 || Object.keys(this.speed_test_result).length > 0
    }
  },
  created () {
    this.init()
    this.get_list()
  },
  destroyed(){
    this.close_modal()
  },
  methods: {
    init(){
      if (!this.$route.query.selftest_id) {
        this.old_url = this.$route.fullPath
        history.pushState(null, null, window.location.href + '?selftest_id=' + this.data.id)
      }
    },
    close_modal () {
      if (this.$route.query.selftest_id) {
        let new_window = this.$route.fullPath.replace('?selftest_id='+ this.data.id, '')
        this.$router.push(new_window)
      }else{
        this.$router.push(this.old_url)
      }
      this.$emit('close')
    },
    get_list(){
      this.load = true
      this.$http.v1.getDeviceTestSelfTestsResult( {selftest_id: this.data.id}, (response) => {
        if (response.data.status === "Results"){
          this.result_data = response.data.result
          this.duration = response.data.duration
          this.server = response.data.server

          if (response.data.result !== null && Object.keys(response.data.result).length > 0) {
            this.ifaces = Object.keys(response.data.result)
            this.th = this.ifaces.map((item) => {
              return {name: item}
            })

            this.parameters = Object.keys(response.data.result[this.ifaces[0]])
            this.tr = this.parameters.map((item) => {
              return {name2: item}
            })
          }

          if (Object.keys(response.data.speed_test_result).length > 0) {

            let speedTestResult = response.data.speed_test_result;
            let resultSpeedTest = {};

            for (let [index, value] of Object.entries(speedTestResult)) {
              let [sim, type] = index.split(' ');
              if (!resultSpeedTest[sim]) {
                resultSpeedTest[sim] = { rx: 0, tx: 0 };
              }
              resultSpeedTest[sim][type] = value
            }

            this.speed_test_result = resultSpeedTest
          }
        }
        this.load = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .selftests__modal {
    .title {
      text-align: center;
      margin-top: 10px;
      text-transform: uppercase;

      span {
        display: block;
      }
    }

    .duration {
      text-align: center;
    }

    .response_table {
      padding: 10px;
    }

    .text-center {
      padding-bottom: 10px;
    }
  }
</style>
